exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1FrJrMqpPJIthKfsGwfcjp{display:flex;border:1px solid #b3b3b3;border-radius:5px;height:200px;overflow:hidden}._2nfCbfKEOEPVUr0zje9GuT{opacity:0.75}._2oF88k-uRd44Ioai1LvirX{flex:5}._2YQRuWy0e0EPRJhNUlo4Sq{flex:3;border-left:1px solid #b3b3b3}@media screen and (max-width: 500px){._2YQRuWy0e0EPRJhNUlo4Sq{max-width:75px;min-width:75px}}\n", ""]);

// Exports
exports.locals = {
	"ClimbAnimation": "_1FrJrMqpPJIthKfsGwfcjp",
	"ClimbAnimationPaused": "_2nfCbfKEOEPVUr0zje9GuT",
	"left": "_2oF88k-uRd44Ioai1LvirX",
	"right": "_2YQRuWy0e0EPRJhNUlo4Sq"
};